module.exports = __webpack_public_path__ + "img/a9.46834041.svg";